import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const TextWrapper = styled.div`
  transition: all 0.4s ease-in-out;
  mask-image: ${({ isOpen }) =>
    isOpen
      ? `linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 90%
  )`
      : `linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 58%,
    rgba(0, 0, 0, 0.10247426607361698) 80%,
    rgba(0, 0, 0, 0) 90%
  )`};
  max-height: ${({ isOpen, maxHeight }) =>
    isOpen ? `${maxHeight}px` : "150px"};
`;

const BottomContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: left;
`;

const ReadMoreButton = styled.a`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  color: var(--color-black);
`;

const Icon = styled(FontAwesomeIcon)`
  margin-left: 5px;
`;

export default function ReadMore({
  readMoreText,
  readMoreIcon,
  readLessText,
  readLessIcon,
  children,
}) {
  const [isOpen, setOpen] = React.useState(false);
  const [maxHeight, setMaxHeight] = React.useState(0);
  const ref = React.useRef(null);

  React.useEffect(() => {
    setMaxHeight(ref.current.scrollHeight);
  });

  return (
    <Wrapper ref={ref}>
      <TextWrapper isOpen={isOpen} maxHeight={maxHeight}>
        {children}
      </TextWrapper>
      <BottomContent>
        <ReadMoreButton onClick={() => setOpen(!isOpen)}>
          {isOpen ? readLessText : readMoreText}
          {isOpen ? (
            <Icon icon={readLessIcon}></Icon>
          ) : (
            <Icon icon={readMoreIcon}></Icon>
          )}
        </ReadMoreButton>
      </BottomContent>
    </Wrapper>
  );
}

ReadMore.propTypes = {
  readMoreText: PropTypes.string,
  readMoreIcon: PropTypes.object,
  readLessText: PropTypes.string,
  readLessIcon: PropTypes.object,
  children: PropTypes.node,
};
